import { render, staticRenderFns } from "./FsFile.vue?vue&type=template&id=37ce5a8a&"
import script from "./FsFile.vue?vue&type=script&lang=js&"
export * from "./FsFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports